import { render, staticRenderFns } from "./TagEditor.vue?vue&type=template&id=74dfb760&"
import script from "./TagEditor.vue?vue&type=script&lang=js&"
export * from "./TagEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports